import { Link, Text } from 'components/ui';

export const ContactSupport = () => {
  return (
    <>
      <Text
        color="blueGray.600"
        fontSize="12.5px"
        fontWeight="normal"
        lineHeight="1.55"
        maxW="340px"
        textAlign="center"
      >
        Got questions? Reach out at{' '}
        <Link
          color="aqua.500"
          fontWeight={600}
          href="mailto:support@ayblehealth.com"
          isExternal={false}
          isUnderlined={false}
          _hover={{ textDecoration: 'underline' }}
        >
          support@ayblehealth.com
        </Link>{' '}
        or call us at{' '}
        <Link
          color="aqua.500"
          fontWeight={600}
          href="tel:8574169299"
          isExternal={false}
          isUnderlined={false}
          _hover={{ textDecoration: 'underline' }}
        >
          (857) 416-9299
        </Link>
      </Text>
    </>
  );
};
